<template>
  <div id="score-summary-containier" class="border-padding">
  <main>
    <div class="row">
      <div class="col-md-2" v-if="season_dropdown.data != undefined">
        <label class="typo__label">Season</label>
        <multiselect
          v-model="season_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="season_dropdown.data"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>

      <div class="col-md-2">
      <label class="typo__label">Season Type</label>
      <multiselect
        v-model="season_type_selected"
        select-label=""
        deselect-label=""
        track-by="id"
        label="text"
        :preselect-first="true"
        :options="season_type_options"
        :searchable="false"
        :show-labels="false"
        :allow-empty="false">
        <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
      </multiselect>
      </div>

      <div class="col-md-2">
        <label class="typo__label">Type</label>
        <multiselect
          v-model="type_selected"
          select-label=""
          deselect-label=""
          track-by="id"
          label="text"
          :preselect-first="true"
          placeholder=""
          :options="type_dropdown"
          :searchable="false"
          :show-labels="false"
          :allow-empty="false">
          <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
    </div>

    <div class="row border-padding">
      <div class="col-md-1">
        <label class="typo__label">Period Number</label>
      </div>
      <div class="col-md-1">
        <multiselect
            v-model="period_comparison_selected"
            select-label=""
            deselect-label=""
            track-by="id"
            label="text"
            :preselect-first="true"
            placeholder=""
            :options="period_comparison_dropdown"
            :searchable="false"
            :show-labels="false"
            :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }">{{ option.text }}</template>
        </multiselect>
      </div>
      <div class="col-md-2">
        <input v-model="period" placeholder="" maxlength="1" size="2">
      </div>
    </div>

    <div class="border-padding">
      Score Margin:
      From: <input v-model="margin_from" placeholder="" maxlength="3" size="3">
      To: <input v-model="margin_to" placeholder="" maxlength="3" size="3">
      (Example: From -3 to -1 will get all possessions when the team was down by 3 points or less)
    </div>

    <div class="border-padding">
      Possession Start Time:
      From: <input v-model="possession_start_time_from" placeholder="" maxlength="3" size="3">
      To: <input v-model="possession_start_time_to" placeholder="" maxlength="3" size="3">
      (Enter time remaining in period in seconds. Ex. For last 2 minutes enter From 120 To 0)
    </div>

    <div class="border-padding">
      <button class="" v-on:click="changeStats()">Get Stats</button>
    </div>

    <div class="note">
      <p>Note that time is the start time of a possession. A possession starting at 3:03 remaining with a shot taken at 2:50 remaining won't be counted if you query for the final 3 minutes</p>
    </div>

    <div v-if="loading">
      Loading.....
    </div>
    <p style="color:red;" v-if="show_error_message">Error Getting Results</p>

    <div v-if="table_data.length > 0">
        <vue-good-table
            :columns="table_columns"
            :rows="table_data"
            :pagination-options="{ enabled: true, perPage: 30}"
            :searchOptions="{ enabled: false}"
            :sort-options="{ enabled: true, initialSortBy: {field: 'team_name', type: 'asc'}}"
            styleClass="vgt-table bordered striped">
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field != 'team_name'">
                <span>
                  {{props.formattedRow[props.column.field]}}
                </span>
              </div>
              <div v-else>
                <span>
                  <b>{{props.formattedRow[props.column.field]}}</b>
                </span>
              </div>
            </template>
            <template slot="table-column" slot-scope="props">
            <span v-if="props.column.hover != undefined" v-b-tooltip.hover :title="props.column.hover">
                {{props.column.label}}
            </span>
            <span v-else>
                {{props.column.label}}
            </span>
            </template>
        </vue-good-table>
    </div>
  </main>
  </div>
</template>

<script>
import axios from 'axios'
import GetDropdownOptions from './mixins/get_dropdown'
import Multiselect from 'vue-multiselect'
import { season } from './mixins/dropdowns'

export default {
  name: 'ScoreTimeSummary',
  components: {
    Multiselect
  },
  mixins: [GetDropdownOptions, season],
  data () {
    return {
      loading: false,
      season_dropdown: {},
      season_selected: undefined,
      season_type_selected: undefined,
      season_type_options: [
        {'id': 'Regular+Season', 'text': 'Regular Season'},
        {'id': 'Playoffs', 'text': 'Playoffs'}
      ],
      type_dropdown: [
        {'id': 'Team', 'text': 'Team'},
        {'id': 'Opponent', 'text': 'Opponent'},
        {'id': 'Lineup', 'text': 'Lineup'},
        {'id': 'LineupOpponent', 'text': 'Lineup Opponent'}
      ],
      type_selected: undefined,
      period_comparison_dropdown: [
        {'id': 'PeriodEquals', 'text': '='},
        {'id': 'PeriodGte', 'text': '>='},
        {'id': 'PeriodLte', 'text': '<='}
      ],
      period_comparison_selected: 'PeriodEquals',
      margin_from: undefined,
      margin_to: undefined,
      possession_start_time_from: undefined,
      possession_start_time_to: undefined,
      period: undefined,
      table_data: [],
      table_columns: {},
      team_columns: [
        {'field': 'team_name', 'label': 'Team'},
        {'field': 'off_poss', 'label': 'Poss', 'type': 'number', 'tooltip': 'Possessions'},
        {'field': 'points', 'label': 'Pts', 'type': 'number'},
        {'field': 'ortg', 'label': 'PPP', 'type': 'decimal', 'tooltip': 'Points Per Possession'},
        {'field': 'fg2m', 'label': 'FG2M', 'type': 'number'},
        {'field': 'fg2a', 'label': 'FG2A', 'type': 'number'},
        {'field': 'fg2pct', 'label': '2pt FG%', 'type': 'percentage'},
        {'field': 'putbacks', 'label': 'Putbacks', 'type': 'number'},
        {'field': 'fg3m', 'label': 'FG3M', 'type': 'number'},
        {'field': 'fg3a', 'label': 'FG3A', 'type': 'number'},
        {'field': 'fg3pct', 'label': '3pt FG%', 'type': 'percentage'},
        {'field': 'efg', 'label': 'eFG%', 'type': 'percentage'},
        {'field': 'fg2m_assist_pct', 'label': '2pt AST%', 'type': 'percentage'},
        {'field': 'fg3m_assist_pct', 'label': '3pt AST%', 'type': 'percentage'},
        {'field': 'ftm', 'label': 'FTM', 'type': 'number'},
        {'field': 'three_pt_sfd', 'label': '3pt SFD', 'type': 'number', 'tooltip': '3pt Shooting Fouls Drawn'},
        {'field': 'three_pt_and1s', 'label': '3pt And1s', 'type': 'number'},
        {'field': 'two_pt_sfd', 'label': '2pt SFD', 'type': 'number', 'tooltip': '3pt Shooting Fouls Drawn'},
        {'field': 'two_pt_and1s', 'label': '2pt And1s', 'type': 'number'},
        {'field': 'take_fouls_drawn', 'label': 'TFD', 'type': 'number', 'tooltip': 'Take Fouls Drawn'},
        {'field': 'orebs', 'label': 'ORebs', 'type': 'number'},
        {'field': 'oreb_pct', 'label': 'OReb%', 'type': 'percentage'},
        {'field': 'live_ball_tos', 'label': 'Live Ball TOs', 'type': 'number'},
        {'field': 'dead_ball_tos', 'label': 'Dead Ball TOs', 'type': 'number'},
        {'field': 'to_pct', 'label': 'TO%', 'type': 'percentage'}
      ],
      lineup_columns: [
        {'field': 'lineup', 'label': 'Lineup'},
        {'field': 'team_name', 'label': 'Team'},
        {'field': 'off_poss', 'label': 'Poss', 'type': 'number', 'tooltip': 'Possessions'},
        {'field': 'points', 'label': 'Pts', 'type': 'number'},
        {'field': 'ortg', 'label': 'PPP', 'type': 'decimal', 'tooltip': 'Points Per Possession'},
        {'field': 'fg2m', 'label': 'FG2M', 'type': 'number'},
        {'field': 'fg2a', 'label': 'FG2A', 'type': 'number'},
        {'field': 'fg2pct', 'label': '2pt FG%', 'type': 'percentage'},
        {'field': 'putbacks', 'label': 'Putbacks', 'type': 'number'},
        {'field': 'fg3m', 'label': 'FG3M', 'type': 'number'},
        {'field': 'fg3a', 'label': 'FG3A', 'type': 'number'},
        {'field': 'fg3pct', 'label': '3pt FG%', 'type': 'percentage'},
        {'field': 'efg', 'label': 'eFG%', 'type': 'percentage'},
        {'field': 'fg2m_assist_pct', 'label': '2pt AST%', 'type': 'percentage'},
        {'field': 'fg3m_assist_pct', 'label': '3pt AST%', 'type': 'percentage'},
        {'field': 'ftm', 'label': 'FTM', 'type': 'number'},
        {'field': 'three_pt_sfd', 'label': '3pt SFD', 'type': 'number', 'tooltip': '3pt Shooting Fouls Drawn'},
        {'field': 'three_pt_and1s', 'label': '3pt And1s', 'type': 'number'},
        {'field': 'two_pt_sfd', 'label': '2pt SFD', 'type': 'number', 'tooltip': '3pt Shooting Fouls Drawn'},
        {'field': 'two_pt_and1s', 'label': '2pt And1s', 'type': 'number'},
        {'field': 'take_fouls_drawn', 'label': 'TFD', 'type': 'number', 'tooltip': 'Take Fouls Drawn'},
        {'field': 'orebs', 'label': 'ORebs', 'type': 'number'},
        {'field': 'oreb_pct', 'label': 'OReb%', 'type': 'percentage'},
        {'field': 'live_ball_tos', 'label': 'Live Ball TOs', 'type': 'number'},
        {'field': 'dead_ball_tos', 'label': 'Dead Ball TOs', 'type': 'number'},
        {'field': 'to_pct', 'label': 'TO%', 'type': 'percentage'}
      ],
      show_error_message: false,
      api_endpoint: 'get-score-time-summary/'
    }
  },
  created () {
    this.loadData()
  },
  watch: {
    '$route': 'updateData',
    '$parent.league': 'changeLeague'
  },
  methods: {
    changeLeague () {
      this.season_dropdown = {}
      this.season_selected = undefined
      this.type_selected = undefined
      this.season_type_selected = undefined
      this.table_data = []
      this.$router.push({name: 'score_time_summary', params: {league: this.$parent.league}})
    },
    setTypeDropdown () {
      if (!this.type_selected) {
        this.type_selected = this.type_dropdown[0]
      }

      if (this.$route.query.Type) {
        this.type_dropdown.forEach((type) => {
          if (type.id === this.$route.query.Type) {
            this.type_selected = type
          }
        })
      }
    },
    setSeasonDropdown (response) {
      this.season_dropdown = this.getSeasonDropdownForLeague(this.$route.params.league)
      if (this.$route.query.Season) {
        this.season_dropdown.data.forEach((season) => {
          if (season.id === this.$route.query.Season) {
            this.season_selected = season
          }
        })
      }

      // this happens on league change  - set to first option
      if (this.season_selected.length === 0) {
        this.season_selected.push(this.season_dropdown.data[0])
      }
    },
    setSeasonTypeDropdown () {
      if (!this.season_type_selected) {
        this.season_type_selected = this.season_type_options[0]
      }
      this.season_type_options.forEach((seasonType) => {
        if (seasonType.id === this.$route.query.SeasonType) {
          this.season_type_selected = seasonType
        }
      })
    },
    setTimeScore () {
      if (this.$route.query.FromMargin) {
        this.margin_from = this.$route.query.FromMargin
      }
      if (this.$route.query.ToMargin) {
        this.margin_to = this.$route.query.ToMargin
      }
      if (this.$route.query.FromTime) {
        this.possession_start_time_from = this.$route.query.FromTime
      }
      if (this.$route.query.ToTime) {
        this.possession_start_time_to = this.$route.query.ToTime
      }
      if (this.$route.query.PeriodEquals) {
        this.period_comparison_selected = this.period_comparison_dropdown[0]
        this.period = this.$route.query.PeriodEquals
      }
      if (this.$route.query.PeriodGte) {
        this.period_comparison_selected = this.period_comparison_dropdown[1]
        this.period = this.$route.query.PeriodGte
      }
      if (this.$route.query.PeriodLte) {
        this.period_comparison_selected = this.period_comparison_dropdown[2]
        this.period = this.$route.query.PeriodLte
      }
    },
    checkIfStatsShouldBeLoaded (response) {
      if (this.$route.query.Season && this.$route.query.SeasonType) {
        this.getStats()
      }
    },
    loadData () {
      this.getDropdown([this.setSeasonDropdown, this.setSeasonTypeDropdown, this.setTypeDropdown, this.setTimeScore, this.checkIfStatsShouldBeLoaded], {})
    },
    updateData () {
      this.table_data = []

      if (this.$route.query.Season && this.$route.query.SeasonType && this.$route.query.Type) {
        this.getStats()
      } else {
        this.loadData()
      }
    },
    changeStats () {
      var params = {}
      params[this.$seasonParam] = this.season_selected.id
      params[this.$seasonTypeParam] = this.season_type_selected.id
      params[this.$typeParam] = this.type_selected.id

      if (this.margin_from && this.margin_from !== '') {
        params[this.$fromMarginParam] = this.margin_from
      } else {
        delete params[this.$fromMarginParam]
      }
      if (this.margin_to && this.margin_to !== '') {
        params[this.$toMarginParam] = this.margin_to
      } else {
        delete params[this.$toMarginParam]
      }
      if (this.possession_start_time_from && this.possession_start_time_from !== '') {
        params[this.$fromTimeParam] = this.possession_start_time_from
      } else {
        delete params[this.$fromTimeParam]
      }
      if (this.possession_start_time_to && this.possession_start_time_to !== '') {
        params[this.$toTimeParam] = this.possession_start_time_to
      } else {
        delete params[this.$toTimeParam]
      }
      if (this.period) {
        delete params['PeriodEquals']
        delete params['PeriodGte']
        delete params['PeriodLte']
        params[this.period_comparison_selected.id] = this.period
      }

      this.$router.push({name: 'score_time_summary', query: params})
    },
    getStats () {
      this.show_error_message = false
      this.table_data = []
      var params = this.$route.query

      if (params.Season && params.SeasonType && params.Type) {
        this.loading = true
        axios.get(process.env.API_BASE_URL + this.api_endpoint + this.$route.params.league, {
          params: params
        })
          .then((response) => {
            if (!response.data.error) {
              this.table_data = response.data.results
              if (this.$route.query.Type.toLowerCase() === 'team' || this.$route.query.Type.toLowerCase() === 'opponent') {
                this.table_columns = this.team_columns
              } else {
                this.table_columns = this.lineup_columns
              }
            } else {
              this.show_error_message = true
            }
            this.loading = false
          }, (error) => {
            this.show_error_message = true
            this.loading = false
            this.error = error
          })
      }
    }
  }
}
</script>

<style>
.note p {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/ScoreTimeSummary.vue